<app-wizard-bar-nav> </app-wizard-bar-nav>

<div class="step-container main-content">
  <div *ngIf="originalQuoteRequestId">
    <h2>You renewed quote {{ originalQuoteRequestId }}.</h2>
    <h3>Your new quote id is {{ this.quoteRequestId }}</h3>
  </div>
  <app-youre-done-content [youreDone]="this.youreDone" [quoteRequestState]="this.quoteRequestState"></app-youre-done-content>
</div>

<app-wizard-step-nav-buttons [hideNext]="true" (backClicked)="back()"></app-wizard-step-nav-buttons>
